import createConverter from './lib/create_converter';
import CustomerAssignee from 'models/customer_assignee';

export default createConverter(CustomerAssignee);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_assignee_converter.js